import { animate, style, transition, trigger } from "@angular/animations";

export const bottomContextMenuAnimation = trigger('slideInOut', [
   transition(':enter', [
     style({ 
       transform: 'translateY(160px)',
       opacity: 0 
     }),
     animate('200ms cubic-bezier(0.42,0,0.1,1)', style({ 
       transform: 'translateY(0)',
       opacity: 1 
     }))
   ]),
   transition(':leave', [
     style({ 
       transform: 'translateY(0)',
       opacity: 1
     }),
     animate('200ms ease-out', style({ 
       transform: 'translateY(160px)',
       opacity: 0 
     }))
   ])
])